import styles from './S04.module.css';
import logo from './images/logo-club-de-madrid.svg';

export default function S04(){

  return (<div className={styles.main}>

  <div className={styles.content}>
    <div className={styles.logoContainer}>
      <img src={logo} alt="" />
    </div>
    <div className={styles.info}>
      <h3>Club de Madrid</h3>
      <p>Club de Madrid is the world's largest forum of democratic former Presidents and Prime Ministers, who leverage their individual and collective leadership experience and global reach to strengthen inclusive democratic practice and improve the well-being of people around the world.
      </p>
      <p>As a non-partisan and international non-profit organisation, it counts on the hands-on governance experience of more than 100 Members from over 70 countries, along with a global network of advisers and partners across all sectors of society.</p>
<p>
This unique alliance stimulates dialogue, builds bridges and engages in advocacy efforts to strengthen public policies and effective leadership through recommendations that tackle challenges such as, inclusion, sustainable development and peace at the national and multilateral level.</p>
    </div>
</div>
  </div>);
}
